"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./as-child.prop.js"), exports);
tslib_1.__exportStar(require("./color.prop.js"), exports);
tslib_1.__exportStar(require("./gap.prop.js"), exports);
tslib_1.__exportStar(require("./height.props.js"), exports);
tslib_1.__exportStar(require("./high-contrast.prop.js"), exports);
tslib_1.__exportStar(require("./layout.props.js"), exports);
tslib_1.__exportStar(require("./leading-trim.prop.js"), exports);
tslib_1.__exportStar(require("./map-prop-values.js"), exports);
tslib_1.__exportStar(require("./margin.props.js"), exports);
tslib_1.__exportStar(require("./padding.props.js"), exports);
tslib_1.__exportStar(require("./prop-def.js"), exports);
tslib_1.__exportStar(require("./radius.prop.js"), exports);
tslib_1.__exportStar(require("./text-align.prop.js"), exports);
tslib_1.__exportStar(require("./text-wrap.prop.js"), exports);
tslib_1.__exportStar(require("./theme.props.js"), exports);
tslib_1.__exportStar(require("./truncate.prop.js"), exports);
tslib_1.__exportStar(require("./weight.prop.js"), exports);
tslib_1.__exportStar(require("./width.props.js"), exports);
//# sourceMappingURL=index.js.map